export default __webpack_public_path__ + "static/media/invisible.f6104273.svg";